export const UnauthorizedPage = () => (
  <div
    className="mds-flex mds-flex-column mds-secondary__background-color mds-secondary__on-background-color main-content"
    style={{
      alignItems: 'center',
      height: '100vh',
      justifyContent: 'center',
    }}
  >
    <div
      className="mds-flex mds-flex-column mds-gap-500"
      style={{ alignItems: 'center' }}
    >
      <h3>Access denied!</h3>
      <p style={{ textAlign: 'center' }}>
        You do not have permission to access this resource.
        <br />
        Please contact the system administrator.
      </p>
    </div>
  </div>
);
